"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.358 9.404c-.48.627-.798 1.526-.798 2.55s.318 1.922.798 2.55c.479.626 1.088.95 1.702.95.615 0 1.224-.324 1.703-.95.48-.628.797-1.527.797-2.55 0-1.024-.318-1.923-.797-2.55s-1.088-.95-1.703-.95c-.614 0-1.223.324-1.702.95m-1.192-.91c.698-.913 1.714-1.54 2.894-1.54s2.197.627 2.894 1.54c.697.91 1.106 2.136 1.106 3.46s-.41 2.55-1.106 3.46c-.697.912-1.713 1.54-2.894 1.54-1.18 0-2.196-.628-2.894-1.54-.696-.91-1.106-2.136-1.106-3.46s.41-2.55 1.106-3.46",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.94 16.046a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M21.7 19a.7.7 0 0 1-.7.7h-3.481l.722.845a.7.7 0 1 1-1.065.91l-1.708-2a.7.7 0 0 1 0-.91l1.708-2a.7.7 0 1 1 1.065.91l-.722.845H21a.7.7 0 0 1 .7.7",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=DecreaseDecimalIcon24.js.map